import { createPerformableConfig, TenantId } from '~/tenants/common/registry';
import { coerceLiteralNumberRequired, FIRST_VERSION_TIMESTAMP } from '~/lib/zod';
import z from 'zod';

export default createPerformableConfig(
  'ai-reel',
  {
    [FIRST_VERSION_TIMESTAMP]: z.object({
      version: coerceLiteralNumberRequired(FIRST_VERSION_TIMESTAMP),
    }),
  },
  {
    name: 'AI Generated Reel from Photos',
    short:
      'Need rich media but working with a limited marketing budget? This product creates a reel by setting still photos to music and motion as an alternative to more expensive video solutions.',
    tenant: TenantId.TWIST_TOURS,
    color: '#7A4F9A',
    images: [],
  },
);
